import { requests } from "../../../api/agent"

export default {
	getPaged     : (values) => requests.post('/MessageToAdmin/getPaged', values),
	answer       : (values) => requests.post("/MessageToAdmin/answer", values),
	read         : (values) => requests.getWithParams("/MessageToAdmin/read", values),
	create       : (values) => requests.post("/MessageToAdmin/create", values),
	createOrg    : (values) => requests.post("/MessageToAdmin/createOrg", values),
	spam         : (values) => requests.post("/MessageToAdmin/spam", values),
	downloadFile : (params) => requests.getFile('/MessageToAdmin/downloadFile', params)
}